import * as React from 'react';
import './calendar-day.module.css';

export class CalendarDayPlaceholder extends React.Component {
    render() {
        return <div styleName='container-empty' />;
    }
}
